export const zeroDecimalCurrency  = ["JPY"]

export let amountOptions = { 
    MIN_AMOUNT_ZERO_D: 1, 
    MIN_AMOUNT_OTHER: 0.01, 
    MAX_AMOUNT_ZERO_D: 9999999,
    MAX_AMOUNT_OTHER: 9999999.99
}